import * as React from 'react';
export const IcSpanner = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.12 15.88l-5.33-5.33A6.101 6.101 0 0015 9a6 6 0 00-6-6 5.521 5.521 0 00-.72.06h-.1a1 1 0 00-.82.67 1 1 0 00.24 1l2.64 2.63-2.83 2.88L4.78 7.6a1 1 0 00-1-.24 1 1 0 00-.67.82v.1A5.52 5.52 0 003 9a6 6 0 006 6 6.101 6.101 0 001.55-.21l5.33 5.33a3 3 0 004.24 0 3 3 0 000-4.24z'
      fill='currentColor'
    />
  </svg>
);
